import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

//Http Client
import { HttpClientModule } from '@angular/common/http';

//datatable
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

//calendar
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

//whiteboard
import { NgWhiteboardModule } from 'ng-whiteboard';

//QRScanner
import { ZXingScannerModule } from '@zxing/ngx-scanner';

import { FileUploaderComponentModule } from './modules/misc/fileUploader/file-uploader/file-uploader.module';
import { CommentComponentModule } from './modules/misc/comments/comment/comment.module';

@NgModule({
  declarations: [AppComponent],
  imports: [BrowserModule, IonicModule.forRoot({mode: 'ios'}), 
  AppRoutingModule, HttpClientModule, NgxDatatableModule,
  BrowserAnimationsModule, NgWhiteboardModule, ZXingScannerModule,

  FileUploaderComponentModule, 
  CommentComponentModule,

  CalendarModule.forRoot({
    provide: DateAdapter,
    useFactory: adapterFactory,
  })],
  providers: [{ provide: RouteReuseStrategy, useClass: IonicRouteStrategy }],
  bootstrap: [AppComponent],
})
export class AppModule {}
